/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many points does a race win score in F1 Fantasy?`)
};

const es_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos puntos otorga ganar una carrera en F1 Fantasy?`)
};

const de_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Punkte bringt ein Rennsieg in F1 Fantasy?`)
};

const nl_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel punten levert een racezege op in F1 Fantasy?`)
};

const fr_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de points rapporte une victoire en course en F1 Fantasy ?`)
};

const it_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti punti vale una vittoria in gara in F1 Fantasy?`)
};

const pt_br2_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos pontos vale vencer uma corrida no F1 Fantasy?`)
};

const pt_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos pontos vale uma vitória numa corrida em F1 Fantasy?`)
};

const ja_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジーでレース優勝は何ポイントですか？`)
};

const zh_f1_fp_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1梦幻联盟中赢得一场正赛能得多少积分？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_fp_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_fp_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_fp_faq1_q", locale)
	if (locale === "en") return en_f1_fp_faq1_q(inputs)
	if (locale === "es") return es_f1_fp_faq1_q(inputs)
	if (locale === "de") return de_f1_fp_faq1_q(inputs)
	if (locale === "nl") return nl_f1_fp_faq1_q(inputs)
	if (locale === "fr") return fr_f1_fp_faq1_q(inputs)
	if (locale === "it") return it_f1_fp_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_fp_faq1_q(inputs)
	if (locale === "pt") return pt_f1_fp_faq1_q(inputs)
	if (locale === "ja") return ja_f1_fp_faq1_q(inputs)
	return zh_f1_fp_faq1_q(inputs)
};